import { render } from "./AddRecordType.vue?vue&type=template&id=173039ba&scoped=true"
import script from "./AddRecordType.vue?vue&type=script&lang=js"
export * from "./AddRecordType.vue?vue&type=script&lang=js"

import "./AddRecordType.vue?vue&type=style&index=0&id=173039ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173039ba"]])

export default __exports__